import { openDB, IDBPDatabase } from "idb";
import { AnswerMode } from "../answer-modes/AnswerModeContainer/AnswerMode";

const DB_NAME = "CustomAnswerModesDB";
const STORE_NAME = "modes";
const PREF_STORE = "preferences";

export class CustomAnswerModeDB {
  private dbPromise: Promise<IDBPDatabase>;

  constructor() {
    // ERROR FIX: Bump version to 2 to trigger 'upgrade' again
    this.dbPromise = openDB(DB_NAME, 2, {
      upgrade(db) {
        // 1. Create Modes Store if missing
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          const store = db.createObjectStore(STORE_NAME, { keyPath: "id" });
          store.createIndex("orderIndex", "orderIndex");
        }

        // 2. ERROR FIX: Create Preferences Store (This was missing!)
        if (!db.objectStoreNames.contains(PREF_STORE)) {
          db.createObjectStore(PREF_STORE);
        }
      },
    });
  }

  async getAllModes(): Promise<AnswerMode[]> {
    const db = await this.dbPromise;
    const modes = await db.getAllFromIndex(STORE_NAME, "orderIndex");
    return modes;
  }

  async addOrUpdateMode(mode: AnswerMode): Promise<void> {
    const db = await this.dbPromise;
    await db.put(STORE_NAME, mode);
  }

  async deleteMode(id: string): Promise<void> {
    const db = await this.dbPromise;
    await db.delete(STORE_NAME, id);
  }

  // Used to save internal indices if needed
  async saveOrder(modes: AnswerMode[]): Promise<void> {
    const db = await this.dbPromise;
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);

    for (let i = 0; i < modes.length; i++) {
      const mode = modes[i];
      if (mode.isCustom) {
        const updatedMode = { ...mode, orderIndex: i };
        await store.put(updatedMode);
      }
    }
    await tx.done;
  }

  // Used for the Visual "iPhone" grid order
  async saveGlobalOrder(orderIds: string[]): Promise<void> {
    const db = await this.dbPromise;
    // This line was failing because PREF_STORE didn't exist
    await db.put(PREF_STORE, orderIds, "buttonOrder");
  }

  async getGlobalOrder(): Promise<string[] | null> {
    const db = await this.dbPromise;
    return await db.get(PREF_STORE, "buttonOrder");
  }
}
